var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIconPremiumMyAccount = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "account",
    width: 35.898,
    height: 35.898,
    viewBox: "0 0 35.898 35.898",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1668",
    "data-name": "Path 1668",
    d: "M35.9,17.949A17.949,17.949,0,1,0,17.949,35.9,17.939,17.939,0,0,0,35.9,17.949ZM17.949,2.1A15.848,15.848,0,0,1,31.081,26.82a17.942,17.942,0,0,0-26.264,0A15.848,15.848,0,0,1,17.949,2.1ZM6.129,28.5a15.842,15.842,0,0,1,23.64,0A15.831,15.831,0,0,1,6.129,28.5Zm0,0",
    fill: "#1b246a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1669",
    "data-name": "Path 1669",
    d: "M172.31,75.724a6.318,6.318,0,0,0,6.31-6.31v-2.1a6.31,6.31,0,0,0-12.621,0v2.1A6.318,6.318,0,0,0,172.31,75.724ZM168.1,67.31a4.207,4.207,0,0,1,8.414,0v2.1a4.207,4.207,0,1,1-8.414,0Zm0,0",
    transform: "translate(-154.361 -56.723)",
    fill: "#1b246a"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconPremiumMyAccount, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-premium-my-account.886ed428.svg";
export { ForwardRef as ReactComponent };